import React, { Component } from 'react'
import PropTypes from 'prop-types'
import SostaOnlineApiService from '../../../services/SostaOnlineApiService'
import DownloadLogo from '../../../assets/download.png'
import moment from 'moment'

const fileDownload = require('js-file-download')

export default class OrdersHistory extends Component {
  static propTypes = {}

  constructor (props) {
    super(props)
    this.state = {
      loading: false,
      orders: []
    }
  }

  async componentDidMount () {
    this.setState({loading: true})
    await this.fetchOrdersHistory()
    this.setState({loading: false})
  }

  async fetchOrdersHistory () {
    const response = await SostaOnlineApiService.fetchMyOrdersHistory()
    this.setState({
      orders: response.data
    })
  }

  onReceiptDownload (item) {
    if (item.ParkTicketOrders.length > 0) {
      const parkTicketId = item.ParkTicketOrders[0].parkTicketId
      SostaOnlineApiService.downloadReceiptMe(parkTicketId).then(data => {
        fileDownload(data, 'ricevuta-abbonamento-' + parkTicketId + '.pdf', 'application/pdf')
      })
    } else if (item.MarkOrders.length > 0) {
      const markId = item.MarkOrders[0].markId
      SostaOnlineApiService.downloadMarkReceiptMe(markId).then(data => {
        fileDownload(data, 'ricevuta-contrassegno-' + markId + '.pdf', 'application/pdf')
      })
    } else if (item.AdjustmentOrders.length > 0) {
      const adjustmentId = item.AdjustmentOrders[0].adjustmentId
      SostaOnlineApiService.downloadAdjustmentReceiptMe(adjustmentId).then(data => {
        fileDownload(data, 'ricevuta-contrassegno-' + adjustmentId + '.pdf', 'application/pdf')
      })
    }
  }

  render () {
    const {loading, orders} = this.state
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-md-12">
            <div className="panel panel-default panel-border">
              <div className="panel-body">
                <div className="titolo-categoria">
                  <legend className="text-left">Storico Acquisti</legend>
                </div>

                <div className="row">
                  <div className="col-md-12">
                    {loading ? (
                      <div>Caricamento in corso...</div>
                    ) : (
                      <table className="table table-bordered">
                        <thead>
                        <tr>
                          <th>ID Ordine</th>
                          <th>ID Contrassegno/Pass</th>
                          <th>Costo</th>
                          <th>Ricevuta</th>
                          <th>Data</th>
                          <th>Stato</th>
                        </tr>
                        </thead>
                        <tbody>
                        {orders.map((item, index) => (
                          <tr key={`order-history-${index}`}>
                            <td>{`SOSTA_COMUNE_DI_EMPOLI-${item.id}`}</td>
                            <td>
                              {item.MarkOrders.length > 0 && (
                                `CONTRASSEGNO N.${item.MarkOrders[0].markId}`
                              )}
                              {item.ParkTicketOrders.length > 0 && (
                                `PASS N.${item.ParkTicketOrders[0].parkTicketId}`
                              )}
                              {item.AdjustmentOrders.length > 0 && (
                                `Pagamento 2018`
                              )}
                            </td>
                            <td>
                              {item.Receipt && (
                                `€ ${Number(item.Receipt.total).toLocaleString('it-IT', {minimumFractionDigits: 2, maximumFractionDigits: 2})}`
                              )}
                            </td>
                            <td>
                              {item.Receipt && (
                                <a onClick={() => this.onReceiptDownload(item)} className="btn-download-user">
                                  <img className="download-logo" style={{width: 20, height: 17, paddingBottom: 1, marginRight: 10}} src={DownloadLogo}>{}</img> Download
                                </a>
                              )}
                            </td>
                            <td>{moment(item.updatedAt).format('L')}</td>
                            <td>
                              {item.status === 0 && (<span className="label label-primary">In Attesa</span>)}
                              {item.status === 1 && (<span className="label label-info">Completato</span>)}
                              {item.status === -1 && (<span className="label label-danger">Rifiutato</span>)}
                            </td>
                          </tr>
                        ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/UserArea/OrdersHistory/OrdersHistory.js